import styled from "styled-components";
import { theme } from "@themes";

export const ContentMenu = styled.div`
  display: ${({ isVisible }) => (isVisible ? "block" : "none")};
  background-color: ${({ theme }) => theme.neutral.white};
  .pro-sidebar-principal {
    z-index: 5;
    min-width: 70px !important;
    height: 89vh;
  }
  .pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout {
    background-color: ${({ theme }) => theme.neutral.white};
    @media only screen and (max-width: 1024px) {
      overflow: hidden;
    }
  }
  .pro-sidebar ::-webkit-scrollbar {
    width: 0.3em;
  }

  .pro-sidebar ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutral.gray[1000]};
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }

  .pro-sidebar ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
  .pro-sidebar.collapsed {
    @media only screen and (max-width: 600px) {
      min-width: 36px !important;
      width: 36px !important;
    }
  }
  /* Flechas de submenú - lógica coherente */
  span[class*="pro-arrow"] {
    border-color: ${({ theme }) => theme.text.primary} !important;
  }
  .pro-menu-item--active span[class*="pro-arrow"],
  .pro-menu-item.selected span[class*="pro-arrow"] {
    border-color: ${({ theme }) => theme.sidebar.selectedText} !important;
  }
  /* Hover colapsado */
  .pro-sidebar.collapsed .pro-menu-item:hover span[class*="pro-arrow"] {
    border-color: ${({ theme }) => theme.neutral.white} !important;
  }
  .sidebar-copyright {
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgb(221, 221, 221);
    ${({ isCollapse }) => {
    return `
        ${isCollapse ? "flex-direction: column;" : ""}
      `;
  }}
    padding: 10px 0 10px 0;
    .sidebar-copyright-text {
      font-style: normal;
      font-weight: 400;
      font-size: 8.5px;
      line-height: 12px;
      color: ${({ theme }) => theme.primary.purple};
    }
    .sidebar-copyright-anchor {
      font-style: normal;
      font-weight: 400;
      font-size: 8.5px;
      line-height: 12px;
      a {
        color: ${({ theme }) => theme.sidebar.selected};
      }
    }
  }
`;

export const ContentChoice = styled.div`
  align-items: center;
  display: flex;
  &:hover {
    .iconMenu {
      color: ${(props) => props.color} !important;
    }
  }
  .selected-item:hover {
    color: ${({ theme }) => theme.sidebar.selected} !important;
  }
`;

export const IconCollapseStyle = styled.div`
  background-color: ${({ theme }) => theme.background.light};
  margin: 0;
  margin-left: 15px;
  button {
    @media only screen and (min-width: 425px) and (max-width: 768px) {
      padding: 5px 5px;
    }
    @media only screen and (max-width: 425px) {
      padding: 10px 8px;
    }
  }
  .menu-icon {
    @media only screen and (max-width: 425px) {
      width: 0.8em;
      height: 0.8em;
    }
  }
`;

export const MenuIcons = styled.div`
  margin-right: 0.7rem;
  font-size: 24px;
  margin-bottom: 0.3rem;
  ${({ isSelected }) => {
    return `
      svg{
        path{
          fill: ${isSelected ? theme.sidebar.selectedText : theme.neutral.iconGray}
        }
      }
    `;
  }}
  ${({ isSelected }) => {
    return `
    span.widget-icon{
      color: ${isSelected ? theme.sidebar.selectedText : theme.neutral.iconGray}
    }
  `;
  }}
  .widget-icon {
    width: 19px;
    height: 19px;
    font-size: 19px;
    top: 4px;
    position: relative;
    right: 2px;
    margin-right: -3px;
  }
`;

export const SubGroupingName = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 0.1em;
  color: #989898;
  margin-bottom: 1rem;
`;

export const SubGroupHR = styled.hr`
  background: ${({ theme }) => theme.text.disabled};
  height: 1px;
  color: ${({ theme }) => theme.text.disabled};
  margin: 0.5rem 0;
`;

export const SearchField = styled.div`
  margin: 10px 12px;
  height: 36px;
  background: ${({ theme }) => theme.neutral.white};
  display: flex;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
  border-radius: 4px;
  padding: 0 10px;
  gap: 6px;
  input {
    font-size: 13px;
    font-weight: 400;
    border: none;
    outline: none;
    flex: 1;
    min-width: 0;
    box-shadow: none;
    background: transparent;
  }
  input:focus {
    box-shadow: none;
    outline: none;
    border: none;
  }
  input::placeholder {
    color: ${({ theme }) => theme.neutral.gray[2000]};
  }
  svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }
`;

export const GroupingName = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 0.1em;
  color: #989898;
  margin-left: 1rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;